<template>
  <div v-if="!isLoading">
    <div v-for="(row, i) in rows" :key="i">
      <l-marker :lat-lng="[row.lat, row.lng]" @click="show(row)" :pane="pane">
        <LTooltip
          v-if="!isPermanentTooltip"
          :content="row.title"
          :options="{ ...tooltipOptions, permanent: false }"
        />
        <LIcon
          :icon-size="[24, 24]"
          :icon-anchor="[12, 12]"
          :icon-url="row.png"
        />
      </l-marker>
    </div>
  </div>
</template>

<script>
import { LIcon, LMarker, LTooltip } from "vue2-leaflet";
import hinanjoJson from "@/assets/shelter/hinanjo.json";
import hukusiJson from "@/assets/shelter/hukusi.json";
import meetingJson from "@/assets/shelter/meeting.json";
import hinanjoPng from "@/assets/shelter/hinanjo.png";
import hukusiPng from "@/assets/shelter/hukusi.png";
import meetingPng from "@/assets/shelter/meeting.png";
import { MapPane } from "../../../enums/Type";
import L from "leaflet";

const ZOOM_LABEL_SHOW = 14;

export default {
  name: "ShelterLayer",
  components: {
    LIcon,
    LMarker,
    LTooltip
  },

  data() {
    return {
      pane: MapPane.ObservatoryMarkersLayer.name,
      isLoading: false,
      tooltipLayer: null,
      tooltipOptions: {
        offset: [0, -15],
        direction: "top"
      }
    };
  },

  computed: {
    map() {
      return this.$store.getters.leafletMap;
    },
    zoom() {
      return Math.floor(this.map.getZoom());
    },
    isPermanentTooltip() {
      return this.zoom >= ZOOM_LABEL_SHOW;
    },
    rows() {
      let rows = [];
      if (this.isShelterVisible) {
        const hinanjo = hinanjoJson.features.map(feature => {
          return {
            kind: "hinanjo",
            lat: feature.geometry.coordinates[1],
            lng: feature.geometry.coordinates[0],
            title: feature.title,
            png: hinanjoPng
          };
        });
        const hukusi = hukusiJson.features.map(feature => {
          return {
            kind: "hukusi",
            lat: feature.geometry.coordinates[1],
            lng: feature.geometry.coordinates[0],
            title: feature.title,
            png: hukusiPng
          };
        });
        rows = hinanjo.concat(hukusi);
      }
      if (this.isMeetingVisible) {
        const meeting = meetingJson.map(feature => {
          return {
            kind: "meeting",
            lat: parseFloat(feature.lat),
            lng: parseFloat(feature.lng),
            title: feature.name,
            png: meetingPng
          };
        });
        rows = rows.concat(meeting);
      }
      return rows;
    },
    isShelterVisible() {
      const features = this.$store.getters.selectedFeatures;
      return features.some(f => f.key === "shelter");
    },
    isMeetingVisible() {
      const features = this.$store.getters.selectedFeatures;
      return features.some(f => f.key === "meeting");
    },
  },

  watch: {
    zoom(newval, oldval) {
      if (newval === oldval) {
        return;
      }
      if (
        (newval >= ZOOM_LABEL_SHOW && oldval < ZOOM_LABEL_SHOW) ||
        (newval < ZOOM_LABEL_SHOW && oldval >= ZOOM_LABEL_SHOW)
      ) {
        this.refreshData();
      }
    },
    rows() {
      this.refreshData();
    }
  },

  created() {
    this.tooltipLayer = L.layerGroup();
    this.tooltipLayer.id = "shelterTooltipLayer";
    this.map.addLayer(this.tooltipLayer);
  },

  beforeDestroy() {
    this.map.eachLayer(layer => {
      if (layer.id === "shelterTooltipLayer") {
        this.map.removeLayer(layer);
      }
    });
  },

  methods: {
    refreshData() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 100);
      this.tooltipLayer.clearLayers();
      if (this.isPermanentTooltip) {
        this.loadPermanentToolTips();
      }
    },

    show(target) {
      console.log(target);
    },

    loadPermanentToolTips() {
      this.tooltipLayer.clearLayers();
      this.rows.forEach(row => {
        const tooltip = L.tooltip({
          ...this.tooltipOptions,
          permanent: true
        });
        tooltip.setContent(row.title);
        tooltip.setLatLng([row.lat, row.lng]);
        tooltip.addTo(this.tooltipLayer);
      });
    }
  }
};
</script>
